<template>
  <div class="app-main-inner check-Criteria">
    <el-card class="box-card" style="height: 100%;" :body-style="{padding:'0px'}">
      <div slot="header">
        <span>{{ $t('SystemMaintenance.ValidationCondition') }}</span>
        <div v-show="isEditCheckRule">
          <template v-if="currOptStatus===optStatusDef.normal">
            <el-button type="primary" @click="showAdd">{{ $t('SystemMaintenance.Create') }}</el-button>
            <el-button type="primary" @click="showEdit">{{ $t('SystemMaintenance.Edit') }}</el-button>
            <el-button type="danger" @click="del">{{ $t('SystemMaintenance.Delete') }}</el-button>
          </template>
          <template v-else>
            <el-button type="primary" @click="save">{{ $t('SystemMaintenance.Save') }}</el-button>
            <el-button type="primary" @click="cancel">{{ $t('SystemMaintenance.Cancel') }}</el-button>
          </template>
        </div>
      </div>
      <div class="app-main-inner-row" :style="{position:'relative','min-height': '300px','height':(isEdit?'auto':'100%')}">
        <div v-show="isEdit" class="pure-loading-mask" />

        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          style="width:100%;"
          @gridReady="params=>gridApi=params.api"
        />
      </div>
      <div v-show="isEditCheckRule && currOptStatus" class="app-main-inner-row">
        <el-form style="width:100%;" label-position="left" label-width="90px">
          <el-form-item :label="$t('SystemMaintenance.Relation')">
            <el-radio-group v-model="oneCheckCriteria.relation" :disabled="!isEdit">
              <el-radio :label="0">{{ $t('SystemMaintenance.And') }}</el-radio>
              <el-radio :label="1">{{ $t('SystemMaintenance.Or') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.FilterBasis')">
            <el-select v-model="oneCheckCriteria.filterDimension" :disabled="!isEdit" style="width:300px;">
              <el-option
                v-for="item in filterDimensions"
                v-show="filterCheckItems(checkRule.checkNode, item.code)"
                :key="item.code"
                :label="item.chineseName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.Operation')">
            <el-select v-model="oneCheckCriteria.operator" :disabled="!isEdit" style="width:300px;">
              <el-option
                v-for="item in operators"
                v-show="filterOperators(oneCheckCriteria.filterDimension, item.code)"
                :key="item.code"
                :label="item.chineseName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.FilterValue')">
            <!-- 自定义业务类型 -->
            <cargo-cascader
              v-if="oneCheckCriteria.filterDimension === customJobTypeCode"
              v-model="oneCheckCriteria.filterValue"
              :select-type="selectTypeNames.basic_data_CutomJobType"
              group-field="type"
              :method-params="{active: true}"
              :group-label-map="groupLabelMap"
              style="width:300px;"
              tag-value="uuid"
            />
            <!-- 海空航线 -->
            <cargo-cascader
              v-else-if="oneCheckCriteria.filterDimension === seaAirRegionCode"
              v-model="oneCheckCriteria.filterValue"
              :select-type="selectTypeNames.basic_data_Region"
              style="width:300px;"
              tag-value="code"
            />
            <!-- 铁路航线 -->
            <cargo-cascader
              v-else-if="oneCheckCriteria.filterDimension === railwayLineCode"
              v-model="oneCheckCriteria.filterValue"
              :select-type="selectTypeNames.basic_data_RailwayLine"
              style="width:300px;"
              tag-value="code"
            />
            <!-- 费用名称 -->
            <cargo-advance-select
              v-else-if="oneCheckCriteria.filterDimension === feeNameCode"
              filterable
              :select-type="selectTypeNames.basic_data_ChargeItem"
              :default-value="Number(oneCheckCriteria.filterValue) || ''"
              options-width="250px"
              tag-value="itemId"
              :tag-name="isZh ? 'zhName' : 'enName'"
              style="width:300px;"
              :disabled="!isEdit"
              @parentCallBack="p=>{oneCheckCriteria.filterValue=p.value}"
            />
            <!-- 运输条款 -->
            <cargo-advance-select
              v-else-if="oneCheckCriteria.filterDimension === masterConditionsCarriageCode || oneCheckCriteria.filterDimension === separateConditionsCarriageCode"
              filterable
              no="freightTerm"
              :select-type="selectTypeNames.basic_data_ShippingTerm"
              :default-multiple-value="toArray(oneCheckCriteria.filterValue) instanceof Array ? toArray(oneCheckCriteria.filterValue) : []"
              options-width="250px"
              style="width:300px;"
              :disabled="!isEdit"
              tag-value="name"
              :multiple="true"
              @parentCallBack="p=>{oneCheckCriteria.filterValue=p.value}"
            />
            <!-- 箱种 -->
            <cargo-advance-select
              v-else-if="oneCheckCriteria.filterDimension === eqTypes"
              filterable
              no="eqType"
              :select-type="selectTypeNames.basic_data_EQType"
              :default-multiple-value="toArray(oneCheckCriteria.filterValue) instanceof Array ? toArray(oneCheckCriteria.filterValue) : []"
              options-width="250px"
              style="width:300px;"
              :disabled="!isEdit"
              tag-name="code"
              tag-value="code"
              :multiple="true"
              @parentCallBack="p=>{oneCheckCriteria.filterValue=p.value}"
            />
            <!-- 销售 -->
            <cargo-advance-select
              v-else-if="oneCheckCriteria.filterDimension === salesCode"
              key="salesCode-multiple"
              no="salesCode-multiple"
              :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'sales',active:true}"
              :default-multiple-value="toArray(oneCheckCriteria.filterValue) instanceof Array ? toArray(oneCheckCriteria.filterValue) : []"
              :select-type="selectTypeNames.basic_data_User"
              filterable
              :clearable="true"
              options-width="250px"
              tag-value="userId"
              :tag-name="isZh ? 'chineseName' : 'englishName'"
              style="width:300px;"
              :disabled="!isEdit"
              :multiple="true"
              @parentCallBack="p=>{oneCheckCriteria.filterValue=p.value}"
            />
            <!-- 船公司 -->
            <cargo-advance-select
              v-else-if="oneCheckCriteria.filterDimension === seaCompany"
              key="seaCompany-multiple"
              no="seaCompany-multiple"
              :method-params="{seaCmp:true,active:true}"
              :default-multiple-value="toArray(oneCheckCriteria.filterValue) instanceof Array ? toArray(oneCheckCriteria.filterValue) : []"
              :select-type="selectTypeNames.basic_data_Company"
              filterable
              :clearable="true"
              options-width="250px"
              tag-value="cmpIdx"
              :custom-label="(item)=>`[${item.shortName}]${item.chineseName}`"
              style="width:300px;"
              :disabled="!isEdit"
              :multiple="true"
              @parentCallBack="p=>{oneCheckCriteria.filterValue=p.cmpIdx}"
            />
            <el-select v-else-if="oneCheckCriteria.filterDimension === integratedOrderType" v-model="oneCheckCriteria.filterValue" :disabled="!isEdit" style="width:300px;">
              <el-option
                v-for="(item,index) in IE_TYPES"
                :key="index"
                :label="item.chineseName"
                :value="item.code"
              />
            </el-select>
            <cargo-advance-select
              v-else-if="oneCheckCriteria.filterDimension === billingPaymentMethod"
              filterable
              no="paymentMethod-multiple"
              :static-options="paymentMethod"
              :default-multiple-value="toArray(oneCheckCriteria.filterValue) instanceof Array ? toArray(oneCheckCriteria.filterValue) : []"
              tag-value="code"
              style="width:300px;"
              :disabled="!isEdit"
              :multiple="true"
              @parentCallBack="p=>{oneCheckCriteria.filterValue=p.code}"
            />
            <cargo-advance-select
              v-else-if="oneCheckCriteria.filterDimension === domesticAndForeignBills"
              filterable
              no="domesticAndForeignBills-multiple"
              :static-options="COUNTRY_TYPE"
              :default-multiple-value="toArray(oneCheckCriteria.filterValue) instanceof Array ? toArray(oneCheckCriteria.filterValue) : []"
              tag-value="code"
              style="width:300px;"
              :disabled="!isEdit"
              :multiple="true"
              @parentCallBack="p=>{oneCheckCriteria.filterValue=p.code}"
            />
            <el-select v-else v-model="oneCheckCriteria.filterValue" :disabled="!isEdit" style="width:300px;">
              <el-option v-for="item in filterValues" :key="item.code" :label="item.chineseName" :value="item.code+''" />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>

import { getLoading } from '@/utils/utilBaseElement'
import { getUuid } from '@/utils'
import { Assert } from '@/utils/validate'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { getNameByCode } from '@/class/cargo/model/parameters/CommonState'

import { getCheckCriteriaByUuid, getCheckCriteriaList, delCheckCriteria } from '@/api/sysManage/baseConfig/checkRuleConfig'
import { AdvanceSelect, TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoCascader from '@/components/Cargo/Common/cargoCascader'
import { getCacheListByKey, getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys as cacheKeys, basicCacheKeys } from '@/utils/cacheConfig'
import lang from '@/lang'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import { IE_TYPES } from '@/class/cargo/model/parameters/ContainerLoadType'
import { COUNTRY_TYPE } from '@/class/cargo/model/parameters/CheckRuleConstants'

export default {
  name: 'CheckCriteria',
  components: {
    cargoUserSelect,
    CargoAdvanceSelect,
    cargoCascader
  },
  props: {
    checkRule: {
      type: Object,
      required: true
    },
    isEditCheckRule: {
      type: Boolean,
      required: true
    }
  },
  data() {
    const initOptStatusDef = { normal: 0, edit: 1 }
    return {
      loading: false,
      NODE_SAVE_PARTNER: CheckRuleConstants.NODE_SAVE_PARTNER,
      NODE_COMMIT_PARTNER: CheckRuleConstants.NODE_COMMIT_PARTNER,
      filterDimensions: CheckRuleConstants.DIMENSIONS,
      operators: CheckRuleConstants.OPERATORS,
      DIMENSION_CUSTOMER_SUPPLIER_TYPE: CheckRuleConstants.DIMENSION_CUSTOMER_SUPPLIER_TYPE,
      optStatusDef: initOptStatusDef,
      currOptStatus: initOptStatusDef.normal,
      gridOptions: {},
      rowData: [],
      gridParams: {},
      gridApi: null,
      columnDefs: [],
      filterValues: [],
      oneCheckCriteria: {
        uuid: '',
        relation: 0,
        filterDimension: '',
        checkRuleUuid: '',
        filterValue: '',
        operator: ''
      },
      customJobTypeCode: CheckRuleConstants.DIMENSION_CUSTOM_JOB_TYPE.code,
      eqTypes: CheckRuleConstants.DIMENSION_EQ_TYPE.code,
      selectTypeNames: TYPE_NAMES,
      groupLabelMap: {
        'SE': lang.t('CargoMsg.Cargo_OceanExport'),
        'SI': lang.t('CargoMsg.Cargo_OceanImport'),
        'AE': lang.t('CargoMsg.Cargo_AirExport'),
        'AI': lang.t('CargoMsg.Cargo_AirImport'),
        'RE': lang.t('CargoMsg.Cargo_RailwayExport'),
        'RI': lang.t('CargoMsg.Cargo_RailwayImport')
      },
      seaAirRegionCode: CheckRuleConstants.DIMENSION_SEA_AIR_REGION.code,
      railwayLineCode: CheckRuleConstants.DIMENSION_RAILWAY_REGION.code,
      feeNameCode: CheckRuleConstants.FEE_NAME.code,
      masterConditionsCarriageCode: CheckRuleConstants.MASTER_CONDITIONS_CARRIAGE.code,
      parentCompany: CheckRuleConstants.DIMENSION_PARENT_COMPANY.code,
      separateConditionsCarriageCode: CheckRuleConstants.SEPARATE_CONDITIONS_CARRIAGE.code,
      salesCode: CheckRuleConstants.DIMENSION_SALES.code,
      seaCompany: CheckRuleConstants.DIMENSION_SEA_COMPANY.code,
      integratedOrderType: CheckRuleConstants.INTEGRATED_ORDER_TYPE.code,
      domesticAndForeignBills: CheckRuleConstants.DOMESTIC_AND_FOREIGN_BILLS.code,
      billingPaymentMethod: CheckRuleConstants.DIMENSION_BILLING_PAYMENT_METHOD.code,
      paymentMethod: [CheckRuleConstants.RECEIVABLE, CheckRuleConstants.PAYABLE],
      IE_TYPES,
      COUNTRY_TYPE: Array.from(COUNTRY_TYPE)
    }
  },
  computed: {
    isEdit() {
      return (this.currOptStatus === this.optStatusDef.edit) && this.isEditCheckRule
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    domesticForeignModel: {
      get() {
        const v = this.oneCheckCriteria.filterValue
        if (Array.isArray(v)) return v
        if (typeof v === 'string' && v.trim()) {
          return v.split(',').filter(Boolean)
        }
        return []
      },
      set(val) {
        this.oneCheckCriteria.filterValue = Array.isArray(val) ? val.join(',') : ''
      }
    }
  },
  watch: {
    isEditCheckRule(val) {
      if (val) {
        // todo
      } else {
        this.currOptStatus = this.optStatusDef.normal
        this.oneCheckCriteria = { ...this.initOneCheckCriteria }
      }
    },
    'oneCheckCriteria.filterDimension'(val) {
      if (val) {
        const currDemension = [...CheckRuleConstants.DIMENSIONS].find(item => {
          return item.code === val
        })
        this.filterValues = currDemension ? currDemension.children : []
      }
    },
    'checkRule.uuid'(val) {
      if (val) {
        this.initData()
      } else {
        this.initStatus()
        this.rowData = []
      }
    }
  },
  created() {
    this.columnDefs = [
      {
        headerName: this.$t('SystemMaintenance.Relation'),
        field: 'relation',
        width: 80,
        cellRenderer: (params) => {
          return params.value === 0 ? this.$t('SystemMaintenance.And') : this.$t('SystemMaintenance.Or')
        }
      }, {
        headerName: this.$t('SystemMaintenance.FilterBasis'),
        field: 'filterDimension',
        width: 100,
        cellRenderer: (params) => {
          return this.getNameByCode(this.filterDimensions, params.value)
        }
      }, {
        headerName: this.$t('SystemMaintenance.Operation'),
        field: 'operator',
        width: 200,
        cellRenderer: (params) => {
          return this.getNameByCode(this.operators, params.value)
        }
      }, {
        headerName: this.$t('SystemMaintenance.FilterValue'),
        field: 'filterValue',
        width: 200,
        cellRenderer: (params) => {
          if (params.data.filterDimension === this.customJobTypeCode) {
            const advanceSelect = new AdvanceSelect(TYPE_NAMES.basic_data_CutomJobType, {}, null, null, { includeAllItem: false })
            let type = ''
            let fieldValue = params.value
            // 铁进和铁出的数据源一样，type都是‘RE’，仅uuid前缀为‘RI_’且长度>22时为 铁进
            // 去除前缀‘RI’，获得真实的fieldValue
            if (fieldValue.startsWith('RI_') && fieldValue.length > 22) {
              type = 'RI'
              fieldValue = fieldValue.substr(3)
            }
            const customJobType = getObjectByCache(basicCacheKeys.basic_data_CutomJobType, 'uuid', fieldValue)
            if (customJobType) {
              return this.groupLabelMap[type || customJobType.type] + '/' + customJobType[advanceSelect.getTagName()]
            }
          } else if (params.data.filterDimension === this.seaAirRegionCode) {
            const region = getObjectByCache(basicCacheKeys.basic_data_Region, 'code', params.value)
            if (region) {
              return this.isZh ? region.name : region.nameEnglish
            }
          } else if (params.data.filterDimension === this.railwayLineCode) {
            const region = getObjectByCache(basicCacheKeys.basic_data_RailwayLine, 'code', params.value)
            if (region) {
              return this.isZh ? region.name : region.nameEnglish
            }
          } else if (params.data.filterDimension === this.feeNameCode) {
            const chargeItem = params.value ? getObjectByCache(basicCacheKeys.basic_data_ChargeItem, 'itemId', Number(params.value)) : null
            if (chargeItem) {
              return this.isZh ? chargeItem.zhName : chargeItem.enName
            }
          } else if (params.data.filterDimension === this.parentCompany) {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_RadioStatusConstants$YES_NO_TYPES, 'code', params.value === 'true', 'chineseName')
          } else if (params.data.filterDimension === this.masterConditionsCarriageCode || params.data.filterDimension === this.separateConditionsCarriageCode || params.data.filterDimension === this.eqTypes) {
            if (typeof params.value === 'string') {
              let resule = params.value
              resule = resule.replace(/[^\x00-\x7F]/g, '')
              resule = JSON.parse(resule)
              return resule.join(',')
            }
            if (typeof params.value === 'object') {
              return params.value.join(',')
            }
          } else if (params.data.filterDimension === this.salesCode) {
            // 反显列表数据
            const userIdJson = params.value instanceof Array ? params.value : JSON.parse(params.value || '[]')
            const arr = userIdJson.map((val) => {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', val, 'auto_sales')
            })
            return arr.join()
          } else if (params.data.filterDimension === this.seaCompany) {
            // 反显列表数据
            const seaCompanyJson = params.value instanceof Array ? params.value : JSON.parse(params.value || '[]')
            const arr = seaCompanyJson.map((val) => {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', val, 'auto_5')
            })
            return arr.join()
          } else if (params.data.filterDimension === this.integratedOrderType) {
            return ColumnUtils.ieTypesLabelFunc(params.value)
          } else if (params.data.filterDimension === this.billingPaymentMethod) {
            const json = params.value instanceof Array ? params.value : JSON.parse(params.value || '[]')
            const arr = json.map((val) => {
              return ColumnUtils.paymentMethodFunc(val)
            })
            return arr.join()
          } else if (params.data.filterDimension === this.domesticAndForeignBills) {
            if (params.value) {
              const json = params.value instanceof Array ? params.value : JSON.parse(params.value || '[]')
              const arr = json.map((val) => {
                return ColumnUtils.countryTypeFunc(val)
              })
              return arr.join()
            }
          }
          let val = this.getFilterValueByDimension(params.data.filterDimension, params.value)
          val = val || this.getFilterValueByDimension(params.data.filterDimension, Number(params.value))
          return val || params.value
        }
      }]

    this.gridOptions = {
      rowSelection: 'single',
      suppressCellSelection: true,
      defaultColDef: {
        resizable: true,
        filter: true
      },
      onRowClicked: this.onRowClick
    }
  },
  mounted() {
    // this.initData()
  },
  methods: {
    getNameByCode,
    getFilterValueByDimension(filterDimensionCode, filterValueCode) {
      const currDemension = [...CheckRuleConstants.DIMENSIONS].find(item => {
        if (item.code === CheckRuleConstants.FEE_NAME.code) {
          item.children = getCacheListByKey(basicCacheKeys.basic_data_ChargeItem)
        }
        return item.code === filterDimensionCode
      })
      const items = currDemension ? currDemension.children : []
      console.log('currDemension', currDemension)
      console.log('items', items)
      return this.getNameByCode(items, filterValueCode)
    },
    filterCheckItems(checkNode, checkItemCode) {
      if (checkNode === CheckRuleConstants.NODE_SAVE_PARTNER.code || checkNode === CheckRuleConstants.NODE_COMMIT_PARTNER.code) {
        return [CheckRuleConstants.DIMENSION_CUSTOMER_SUPPLIER_TYPE.code].includes(checkItemCode)
      } else if (!(checkNode === CheckRuleConstants.NODE_SAVE_INVOICE.code || checkNode === CheckRuleConstants.NODE_INVOICE_CONFIRM_OR_RECEPT.code)) {
        return ![CheckRuleConstants.DIMENSION_TAX_NATURE.code].includes(checkItemCode)
      }
      return true
    },
    initStatus() {
      this.currOptStatus = this.optStatusDef.normal
      this.oneCheckCriteria = { ...this.initOneCheckCriteria() }
    },
    initData() {
      this.initStatus()
      this.fetchDataList()
    },
    onRowClick(event) {
      this.oneCheckCriteria = { ...event.data }
      console.log(this.oneCheckCriteria.filterValue)
    },
    /**
       * 获取 详情
       * @param forceRequest 强制发送请求获取数据
       * @returns {Promise<void>}
       */
    async getCheckCriteriaDetail(forceRequest = false) {
      this.loading = getLoading()
      await getCheckCriteriaByUuid(this.oneCheckCriteria.uuid).then(res => {
        this.oneCheckCriteria = res.data
      }).finally(() => {
        this.loading.close()
      })
    },
    async fetchDataList() {
      this.loading = getLoading()
      await getCheckCriteriaList({ checkRuleUuid: this.checkRule.uuid }).then(res => {
        this.rowData = res.data
      }).finally(() => {
        this.loading.close()
      })
    },
    async showAdd() {
      await Assert.isTrue(this.currOptStatus === this.optStatusDef.normal, '当前处于编辑状态，不可新建')
      this.oneCheckCriteria = { ...this.initOneCheckCriteria() }
      // 添加临时唯一标识 用于后面修改显示
      this.oneCheckCriteria.uuid = 'addCriteria_' + getUuid()
      this.currOptStatus = this.optStatusDef.edit
    },
    async showEdit() {
      const row = this.getGridSelected(this.gridOptions)
      if (!row) {
        return
      }
      Object.assign(this.oneCheckCriteria, row)
      this.currOptStatus = this.optStatusDef.edit
    },
    async del() {
      if (!this.getGridSelected(this.gridOptions)) {
        return
      }
      await Assert.isTrue(this.currOptStatus === this.optStatusDef.normal, this.$t('SystemMaintenance.CurrentlyModeUnableToDelete'))
      await this.$confirm(this.$t('SystemMaintenance.AreToDeleteTheRecord'), this.$t('SystemMaintenance.Prompt'), { type: 'waring' })
      this.loading = getLoading()
      delCheckCriteria(this.oneCheckCriteria.uuid).then(async res => {
        this.$message.success(this.$t('SystemMaintenance.DeleteSuccess'))
        this.rowData = this.rowData.filter(item => item.uuid !== this.oneCheckCriteria.uuid)
        this.oneCheckCriteria = { ...this.initOneCheckCriteria() }
        this.currOptStatus = this.optStatusDef.normal
      }).finally(() => {
        this.loading.close()
      })
    },
    async cancel() {
      this.initStatus()
    },
    async checkForm() {
      const { filterDimension,
        filterValue } = this.oneCheckCriteria
      await Assert.isNotBlank(filterDimension, this.$t('SystemMaintenance.PleaseSelectAFilterBasis'))
      await Assert.isNotBlank(filterValue, this.$t('SystemMaintenance.PleaseSelectTheFilterValue'))
    },
    async save() {
      await this.checkForm()
      // this.oneCheckCriteria.checkRuleUuid = this.checkRule.uuid
      // saveCheckCriteria(this.oneCheckCriteria, this.oneCheckCriteria.uuid).then(async res => {
      this.$message.success(this.$t('SystemMaintenance.SaveSuccess'))
      this.rowData = this.rowData.filter(item => item.uuid !== this.oneCheckCriteria.uuid)
      this.rowData.push({ ...this.oneCheckCriteria })
      this.cancel()
    },
    getGridSelected(gridOptions) {
      const cell = gridOptions.api.getFocusedCell()
      const nodes = gridOptions.api.rowModel.rowsToDisplay
      const node = (cell && nodes.length > 0) ? nodes.find(node => node.rowIndex === cell.rowIndex) : null
      if (!node || !node.data) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseSelectDataFirst'))
        return null
      }
      return node.data
    },
    initOneCheckCriteria() {
      return {
        uuid: '',
        relation: 0,
        filterDimension: '',
        checkRuleUuid: '',
        filterValue: '',
        operator: ''
      }
    },
    toArray(val) {
      if (!val && val !== 0) return []
      if (val instanceof Array) return val
      if (typeof val === 'string') {
        const s = val.trim()
        if (!s) return []
        try {
          const parsed = JSON.parse(s)
          return Array.isArray(parsed) ? parsed : []
        } catch (e) {
          return []
        }
      }
      return []
    },
    filterOperators(filterDimension, operatorCode) {
      if (filterDimension === CheckRuleConstants.DIMENSION_CUSTOMER_SUPPLIER_TYPE.code || filterDimension === CheckRuleConstants.DIMENSION_SEA_COMPANY.code || filterDimension === CheckRuleConstants.DIMENSION_CROSS_DELEGATION_ORDER.code ||
          filterDimension === CheckRuleConstants.INTEGRATED_ORDER_TYPE.code || filterDimension === CheckRuleConstants.CLIENT_SCOPE_HAVE_CHARGE.code || filterDimension === CheckRuleConstants.LOGIC_INVOICE_NATURE.code ||
          filterDimension === CheckRuleConstants.COUNTER_PARTY_BILLING_NO.code) {
        return operatorCode === CheckRuleConstants.EQUAL.code || operatorCode === CheckRuleConstants.NOT_EQUAL.code
      }
      if (filterDimension === CheckRuleConstants.DIMENSION_EQ_TYPE.code || filterDimension === CheckRuleConstants.DIMENSION_PARENT_COMPANY.code) {
        return operatorCode === CheckRuleConstants.EQUAL.code
      }
      return true
    }
  }
}
</script>

<style scoped lang="scss">
  .check-Criteria .box-card>>>.el-card__header{
    padding:8px 20px!important;
    div{
      display: flex;
      justify-content: space-between;
    }
  }
  .check-Criteria .box-card>>>.el-card__body{
    height:calc(100% - 35px)!important;
  }
</style>
